import React from 'react';
import styled, { StyledComponent } from 'styled-components';
import ButtonItem from './ButtonItem';

interface IProps {
  menus: any[];
  position?: string;
}

interface IActionWrapperProps {
  position: string;
}

const ActionButton: React.FC<IProps> = ({ menus, position = 'center' }) => {
  return (
    <ActionWrapper position={position}>
      {menus.map((menu, index) => (
        <ButtonItem key={index} menu={menu} />
      ))}
    </ActionWrapper>
  );
};

export default ActionButton;

const ActionWrapper: StyledComponent<
  'div',
  any,
  IActionWrapperProps,
  never
> = styled.div<IActionWrapperProps>`
  display: flex;
  justify-content: ${(props) => props.position};
  align-items: 'center';
  & > * + * {
    margin-left: 48px;
  }
`;
